// API endpoint configuration
export const API_ENDPOINTS = {
  auth: {
    login: '/auth/login',
    register: '/auth/register',
    logout: '/auth/logout',
    refresh: '/auth/refresh',
  },
  content: {
    posts: '/posts',
    articles: '/articles',
    videos: '/videos',
    comments: '/comments',
  },
  users: {
    profile: '/users/profile',
    follow: (userId: string) => `/users/${userId}/follow`,
    unfollow: (userId: string) => `/users/${userId}/unfollow`,
  },
  categories: {
    list: '/categories',
    bySlug: (slug: string) => `/categories/${slug}`,
  },
  interactions: {
    like: (type: string, id: string) => `/${type}/${id}/like`,
    unlike: (type: string, id: string) => `/${type}/${id}/unlike`,
    bookmark: (type: string, id: string) => `/${type}/${id}/bookmark`,
    unbookmark: (type: string, id: string) => `/${type}/${id}/unbookmark`,
  },
  search: '/search',
  trending: '/trending',
  notifications: '/notifications',
} as const;